import {mergeConfig} from '../../configStore'
import {field} from '../field'
import {BlockContentField, FieldReturn} from '../../types'

const defaultProps: Partial<BlockContentField> = {
  title: 'Content',
  name: 'content',
}

export const blockContent = (
  props?: BlockContentField,
  mergeProps?: Partial<BlockContentField>,
): FieldReturn =>
  field('blockContent', mergeConfig('blockContent', props, mergeProps, defaultProps))
